<template>
    <form :id="formName" :name="formName">
    <nav class="form-inline filter_filterArea row">
        <div class="filterInputBox" :class="{vSliderInput: showToggleButton, 'single-row': singleRowMode}" :style="{'max-height': `${filterMaxHeight}px`}">
            <a v-if="showToggleButton" @click="toggleSingleRowMode" href="#" class="btn btn-info showeMoreInputsBtn addTooltip" :data-tooltip-text="lang('filter_show_hide_more_filters')" data-original-title title>
                <i v-if="singleRowMode" class="fa fa-caret-down"></i>
                <i v-else class="fa fa-caret-up"></i>
            </a>
            <div v-for="searchable in filterData" :class="{'form-group': searchable.type !== 'select2', 'displayInlineFlex': searchable.type === 'select2'}">
                <input v-if="searchable.type === 'text'"
                       class="form-control ignoreValidation"
                       type="text"
                       :aria-label="searchable.name"
                       :id="searchable.name"
                       :name="searchable.name"
                       :ref="searchable.name"
                       v-bind="searchable.rules"
                       v-model="searchable.value"
                       :placeholder="!!searchable.placeholder ? searchable.placeholder : lang(searchable.name)"
                       @keyup="onQueryChange($event, filterData)"/>

                <input v-if="searchable.type === 'hidden'"
                       type="hidden"
                       :aria-label="searchable.name"
                       :id="searchable.name"
                       :name="searchable.name"
                       :ref="searchable.name"
                       v-bind="searchable.rules"
                       v-model="searchable.value"
                       :placeholder="!!searchable.placeholder ? searchable.placeholder : lang(searchable.name)"
                       @keyup="onQueryChange($event, filterData)"/>

                <select v-else-if="searchable.type === 'select'"
                        :ref="searchable.name"
                        :name="searchable.name"
                        :id="searchable.name"
                        :aria-label="searchable.name"
                        v-bind="searchable.rules"
                        v-model="searchable.value"
                        class="form-control ignoreValidation"
                        @change="onQueryChange($event, filterData)">
                    <option v-if="searchable.placeholder" value="">{{searchable.placeholder}}</option>
                    <option v-for="option in searchable.options" v-bind:value="option.id">{{option.text}}</option>
                </select>
                <np-select2
                        v-else-if="searchable.type === 'select2'"
                        :ref="searchable.name"
                        :name="searchable.name"
                        :id="searchable.name"
                        :aria-label="searchable.name"
                        :no-wrapper="true"
                        :check-config="false"
                        :mode="'filter'"
                        class="form-control filterSelect2"
                        :placeholder="!!searchable.placeholder ? searchable.placeholder : lang(searchable.name)"
                        v-bind="searchable.rules"
                        v-model="searchable.value"
                        @update:model-value="onQueryChange($event, filterData)"
                        :parameters="getSearchableOptions(searchable)">
                </np-select2>
                <np-date-picker v-else-if="searchable.type === 'date'"
                        class="form-control ignoreValidation"
                        :placeholder="lang(searchable.name)"
                        :aria-label="searchable.name"
                        :ref="searchable.name"
                        :check-config="false"
                        :date-format="!!searchable.format ? searchable.format : 'en-US' "
                        v-model="searchable.value"
                        @update:model-value="onQueryChange($event, filterData)">
                </np-date-picker>
            </div>
        </div>
        <div class="myDropdown"><a class="btn btn-default btn-sm showMoreFilters addTooltip" href="#"
                                   data-tooltip-text="Show/Hide More Filters">...</a>
            <ul class="dropdown-menu"></ul>
        </div>
        <div class="filterControls">
            <button type="button" class="btn btn-default btn-sm btn-with-label" @click="filter"   href="#"><span
                    class="btn-label"><i class="fa fa-search"></i></span>{{lang('filter')}}
            </button>
            <a class="btn btn-default btn-sm clearFiltering addTooltip" @click="clear" :data-tooltip-text="lang('clear_filters')">
                <i class="fa fa-ban"></i>
            </a>
            <a v-if="downloadUrl" class="btn btn-default btn-sm addTooltip" :href="dynamicDownloadLink" target="_blank" :data-tooltip-text="lang('download')">
                <i class="fa fa-download"></i>
            </a>
            <!--
            <a v-if="downloadUrl" class="btn btn-default btn-sm " href="#" @click="download">
                <i class="fa fa-download"></i>
            </a>
            -->
        </div>
    </nav>
     </form>
</template>

<script>
    import NPInput from '../np-input.vue';
    import NPDatePicker from '../np-date-picker.vue';
    import NPSelect2 from '../np-select2.vue';
    import _ from 'lodash';
    export default {
        name: 'np-filter-bar',
        props: {
            query: Array,
            downloadUrl: '',
        },
        mounted: function() {
            this.updateToggleButton()
            window.addEventListener('resize', this.updateToggleButton);
        },
        data: function() {
            return {
                filterData: _.cloneDeep(this.query),
                showToggleButton: false,
                singleRowMode: true,
                maxHeight: 31,
                formName: 'filter_' + Math.random()
            }
        },
        watch: {
            // update filterData options
            'query': {
                handler: function (newVal) {
                    let val_change_occured = false;
                    this.filterData.forEach(obj => {
                        if(obj.hasOwnProperty('options')) {
                            let new_obj = newVal.find(newVa => {
                                return newVa.name === obj.name
                            });
                            obj.options = !!new_obj ? !!new_obj.options ? new_obj.options : obj.options : obj.options;
                            if(!!obj.options && !obj.options.find(opt => {
                                return opt.id === obj.value
                            })) {
                                val_change_occured = true;
                                obj.value = '';
                            }
                        }
                    });
                    if(val_change_occured) {
                        this.onQueryChange('', false);
                    }
                }
            }
        },
        computed: {
            dynamicDownloadLink: function() {
                const query_strs = [];
                const queryObj = this.getQuery();
                for (var key in queryObj) {
                    if (queryObj.hasOwnProperty(key)) {
                        query_strs.push(`${key}=${queryObj[key]}`);
                    }
                }
                if (query_strs.length > 0) {
                    const url = this.downloadUrl.endsWith('/') ? this.downloadUrl : this.downloadUrl + '/';
                    return url + '?' + query_strs.join('&');
                } else {
                    return this.downloadUrl;
                }
            },
            filterMaxHeight: function() {
                return this.singleRowMode ? 31 : this.maxHeight;
            }
        },
        methods: {
            getSearchableOptions: function (searchable) {
                let vm = this;
                if (!!searchable.dependent_on) {
                    if (typeof searchable.dependent_on !== "string"){
                      let dependents = searchable.dependent_on;
                      let options = searchable.options;
                        dependents.forEach(dependent_on => {
                          let dependent = vm.filterData.find(val => {return val.name == dependent_on});
                          options = !!dependent ? options.filter(obj => {return obj.hasOwnProperty(dependent.name) && obj[dependent.name] === dependent.value}) : options;
                      });
                        return options;
                    } else{
                        let dependent = this.filterData.find(obj => {return obj.name === searchable.dependent_on});
                        return !!dependent ? searchable.options.filter(obj => {return obj.hasOwnProperty(dependent.name) && obj[dependent.name] === dependent.value}) : []
                    }

                }
                return searchable.options
            },
            updateToggleButton: function() {
                const inputs = document.querySelectorAll('.form-control');
                let previousRect = null;
                let hasMultiRow = false;
                let min = Number.MAX_SAFE_INTEGER;
                let max = 0;
                inputs.forEach(input => {
                    const rect = input.getBoundingClientRect();
                    if (rect.y < min) min = rect.y;
                    if (rect.y + rect.height > max) max = rect.y + rect.height;
                    if (previousRect && rect.y >= previousRect.y + previousRect.height) {
                        hasMultiRow = true;
                    }
                    previousRect = rect;
                })
                this.maxHeight = max - min;
                this.showToggleButton = hasMultiRow;
            },
            download: function() {
                const config = {
                    responseType: 'blob'
                };
                this.getAxiosInstance().get(this.dynamicDownloadLink, config)
                    .then(function(response) {
                        const a = document.createElement('a');
                        const url = window.URL.createObjectURL(response.data);
                        a.href = url;
                        a.target = '_blank';
                        a.click();
                        //window.URL.revokeObjectURL(url);
                        //console.log(response.data)
                    })
            },
            toggleSingleRowMode: function() {
                this.singleRowMode = !this.singleRowMode;
            },
            clear: function() {
                this.filterData.forEach(data => {
                    data.value = '';
                })
                this.$emit('clear');
            },
            isValidUKDate: function(date) {
                const datePattern = new RegExp('^(0[1-9]|[12][0-9]|3[01])[\\-](0?[1-9]|1[012])[\\-](19[0-9]{2}|2[0-9]{3})$');
                if (datePattern.test(date)) {
                    return true;
                }
                return false;
            },
            isValidUSDate: function(date) {
                const datePattern = new RegExp('^(0?[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19[0-9]{2}|2[0-9]{3})$');
                if (datePattern.test(date)) {
                    return true;
                }
                return false;
            },
            convertUSDateTOUKDate(input) {
                var datePart = input.match(/\d+/g),
                    month = datePart[0],
                    // get only two digits
                    day = datePart[1],
                    year = datePart[2];
                return day + '-' + month + '-' + year;
            },
            getQuery: function() {
                const query = {};
                this.filterData.forEach(data => {
                    if (data.value !== '' && (data.type !== 'date' || !!data.format || this.isValidUKDate(data.value) || this.isValidUSDate(data.value)) ) {
                        if (!data.format && this.isValidUSDate(data.value)){
                            query[data.name] = this.convertUSDateTOUKDate(data.value);
                        }else{
                        query[data.name] = data.value;
                        }
                    }
                })
                return query;
            },
            filter: function() {
                this.$emit('filter', this.getQuery());
            },
            onQueryChange: function ($event, filterData) {
                this.$emit('change', this.getQuery(), filterData, $event);
            }

        },
        components: {
            'np-input': NPInput,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
        },
    }
</script>
<style>
    .displayInlineFlex {
        margin: 0 2px 5px 0;
        display: inline-flex;
    }
</style>